"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoClientError = exports.ErrorCode = void 0;
exports.wrapError = wrapError;
exports.createError = createError;
const api_1 = require("../api");
const error_1 = require("../api/error");
var api_2 = require("../api");
Object.defineProperty(exports, "ErrorCode", { enumerable: true, get: function () { return api_2.ErrorCode; } });
const excludeFields = new Set(["toJSON", "stack", "detailed", "handled", "inner", "aggregates"]);
function serialize(err) {
    var _a;
    if (err == null) {
        return null;
    }
    if ("toJSON" in err && typeof err.toJSON === "function") {
        return err;
    }
    return {
        err: (_a = err.name) !== null && _a !== void 0 ? _a : err.constructor.name,
        message: err.message,
        stack: err.stack,
    };
}
function wrapError(err) {
    if (err == null) {
        return null;
    }
    if ((0, error_1.isVideoClientError)(err)) {
        return err;
    }
    if (err instanceof Error) {
        return createError(api_1.ErrorCode.NativeError, err.message, { type: err.name });
    }
    if (err instanceof ErrorEvent) {
        return createError(api_1.ErrorCode.NativeError, err.message, { type: err.type });
    }
    return createError(api_1.ErrorCode.NativeError, String(err), { type: "unknown" });
}
function concatMessages(code, message, inner) {
    let result = message == null ? `[${code}]` : `[${code}] ${message}`;
    while (inner != null) {
        result += `; [${inner.code}] ${inner.message}`;
        inner = inner.inner;
    }
    return result;
}
function createError(code, message, data, inner = null) {
    return new VideoClientError(code, message, data, inner);
}
/**
 * Generic VideoClient error. All errors VDC errors inherits this class
 */
class VideoClientError extends Error {
    constructor(code, message, data = {}, inner = null) {
        super(concatMessages(code, message, wrapError(inner)));
        this.inner = null;
        this.innerCodes = new Set();
        this.muted = false;
        this.code = code;
        this.inner = wrapError(inner);
        for (const [key, val] of Object.entries(data !== null && data !== void 0 ? data : {})) {
            this[key] = val;
        }
    }
    static log(err, logger) {
        logger.error(err.message, { err });
    }
    get isMuted() {
        return this.muted;
    }
    toJSON() {
        var _a;
        const json = {
            message: this.message,
            stack: (_a = this.stack) !== null && _a !== void 0 ? _a : null,
            inner: serialize(this.inner),
            aggregates: this.aggregates(),
        };
        for (const k of Object.keys(this)) {
            if (!excludeFields.has(k)) {
                json[k.toString()] = this[k];
            }
        }
        return json;
    }
    aggregates() {
        if (this.inner instanceof VideoClientError) {
            return {
                ...this.inner.aggregates(),
                errCode: this.code,
            };
        }
        return {
            errCode: this.code,
        };
    }
    mute() {
        this.muted = true;
    }
}
exports.VideoClientError = VideoClientError;
//# sourceMappingURL=errors.js.map